export const LorenDoorWindowStateConstants: Map<number, string> = new Map<
  number,
  string
>([
  [1, `automation_plans.binary_is_closed_short`],
  [0, `automation_plans.binary_is_open_short`],
]);

export const LorenPIRStateConstants: Map<number, string> = new Map<
  number,
  string
>([
  [0, "automation_plans.movement_false"],
  [1, "automation_plans.movement_true"],
]);

export const LorenLightStateConstants: Map<number, string> = new Map<
  number,
  string
>([
  [0, "automation_plans.light_false"],
  [1, "automation_plans.light_true"],
]);

export const LorenSmokeStateConstants: Map<number, string> = new Map<
  number,
  string
>([
  [0, "automation_plans.smoke_false"],
  [1, "automation_plans.smoke_true"],
]);

export const LorenIgnitionStateConstants: Map<number, string> = new Map<
  number,
  string
>([
  [0, "automation_plans.ignition_on"],
  [1, "automation_plans.ignition_off"],
]);

export const LorenTiltStateConstants: Map<number, string> = new Map<
  number,
  string
>([
  [0, "automation_plans.tilt_false"],
  [1, "automation_plans.tilt_true"],
]);

export const LorenWaterLeakStateConstants: Map<number, string> = new Map<
  number,
  string
>([
  [0, "automation_plans.water_leak_false"],
  [1, "automation_plans.water_leak_true"],
]);

export const LorenStateConstants: Map<number, string> = new Map<number, string>([
  [0, "asset.state_off"],
  [1, "asset.state_on"],
]);
